import React, { Component } from 'react';
import Icon from '../../icons/Icon';
import { changeCurrentComponent, changeSidebarCollapse, toggleHamburgerMenu } from '../../redux/actions/PageActions';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';

class SidebarCollapseItem extends Component<Props> {
  public render() {
    const { collapsed } = this.props;
    return (
      <span className={`${collapsed && ''} absolute top-6 right-2 hover:text-f-purple hidden lg:block cursor-pointer`} onClick={this.collapseSidebar}>
        {collapsed ? (
          <Icon size={20} icon={'double-arrow-right'} className={'text-f-black-4 hover:text-f-purple'} />
        ) : (
          <Icon size={24} icon={'double-arrow-left'} className={'text-f-black-4 hover:text-f-purple'} />
        )}
      </span>
    );
  }

  private collapseSidebar = () => {
    const { changeSidebarCollapse, collapsed } = this.props;
    changeSidebarCollapse(!collapsed);
  };
}

interface Props extends ReduxProps {}

const mapDispatchToProps = {
  changeSidebarCollapse,
  changeCurrentComponent,
  toggleHamburgerMenu,
};

const mapStateToProps = (state: RootState) => ({
  collapsed: state.page.sidebarCollapsed,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SidebarCollapseItem);
